import React, { useState } from "react";
import AnimatedButton from "../components/AnimatedButton";
import { Modal, Form, Row, Col } from "react-bootstrap";
import emailjs from "@emailjs/browser";

const ContactPopup = ({ show, handleClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("Sending...");

    emailjs
      .send(
        "service_vydy57d", // replace with your Service ID
        "template_90xz6eo", // replace with your Template ID
        formData,
        "QEbjBqO2un94y69Yj" // replace with your Public Key
      )
      .then(
        () => {
          setStatus("✅ Message sent successfully!");
          setFormData({ name: "", email: "", phone: "", message: "" });
          setTimeout(() => {
            setStatus("");
            handleClose(); // auto-close popup on success
          }, 2000);
        },
        (error) => {
          console.error(error);
          setStatus("❌ Failed to send message. Try again.");
        }
      );
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Get in Touch</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col xs={12} sm={12}>
              <Form.Group className="mb-3" controlId="name">
                <Form.Label>Name*</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6}>
              <Form.Group className="mb-3" controlId="email">
                <Form.Label>Email*</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group className="mb-3" controlId="phone">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="tel"
                  placeholder="Enter your phone number"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12}>
              <Form.Group className="mb-3" controlId="message">
                <Form.Label>Message*</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Your message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="d-grid">
            <AnimatedButton
              text="Send Message"
              type="submit"
              className="py-3"
            />
          </div>

          {status && (
            <p
              className={`mt-3 text-center ${
                status.includes("successfully") ? "text-success" : "text-danger"
              }`}
            >
              {status}
            </p>
          )}
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ContactPopup;
